<template>
  <div class="remote-table">
    <div class="display-box">
      <div class="filter-box">
        <el-input class="filter" v-model="searchValue" clearable @input="onSearchStringChange" placeholder="输入关键字搜索"></el-input>
      </div>

      <div class="data-table">
        <el-table
          ref="remoteTable"
          class="common-el-table-styles"
          v-loading="loading"
          @row-click="onRowClick"
          @cell-mouse-enter="onCellHover"
          :data="tableData"
          border
          height="263"
          style="width: 100%"
        >
          <el-table-column width="55">
            <template slot="header" slot-scope="{ row }">
              <el-checkbox
                :row="row"
                :disabled="seletcLimit"
                :value="checkState.check"
                @change="onTableAllCheck"
                :indeterminate="checkState.indeterminate"
              ></el-checkbox>
            </template>

            <template slot-scope="{ row }">
              <span @click.stop.prevent="onRowClick(row)">
                <el-checkbox :value="row.check"></el-checkbox>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="名称"> </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="results-box">
      <div class="header">
        <div>
          <span class="result-tab"> 已选({{ selectedLens }}/{{ max }}) </span>
        </div>
        <span class="clear" @click="removeAll">清空</span>
      </div>

      <div class="row-list">
        <div class="row-item" v-for="res in value" :key="res.id">
          <span>{{ res.name }}</span>
          <i @click="removeItem(res)" class="remove el-icon-error"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * @description: 本组件为远程搜索，提供结果显示、全部清空操作
 * @usage: value为id数组
 * @usage: max为最大可选数量
 * @usage: data为数据源，由外部remoteMethod根据searchValue搜索得到
 *
 * 百度、快手的批量修改、批量复制用到本组件
 */

let timer = 0
export default {
  props: {
    value: {
      type: Array
    },
    data: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    remoteMethod: {
      type: Function
    },
    max: {
      type: Number
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    checkState() {
      const someCheck = this.tableData.some((row) => row.check)
      const allCheck = this.tableData.length && this.tableData.every((row) => row.check)
      return {
        check: allCheck,
        indeterminate: !allCheck && someCheck
      }
    },
    selectedIds() {
      return this.value.map((row) => row.id)
    },
    tableData() {
      return this.data.map((row) => {
        return { ...row, check: this.selectedIds.includes(row.id) }
      })
    },
    selectedLens() {
      return this.value.length
    },
    seletcLimit() {
      return this.selectedLens >= this.max
    }
  },
  methods: {
    /**
     * @description: 勾选或取消勾选
     * @param {*} row
     */
    onRowClick(row) {
      const unCheck = !this.selectedIds.includes(row.id)

      if (unCheck === true) {
        if (this.seletcLimit) return
      }

      let newValue = []

      if (unCheck) {
        newValue = this.value.concat(row)
      } else {
        newValue = this.value.filter((r) => r.id !== row.id)
      }

      // 只更新id数据，用于媒体接口提交
      this.$emit('input', newValue)
    },

    onTableAllCheck(isCheck) {
      let offset = this.max - this.selectedLens
      offset = offset > 0 ? offset : 0
      if (isCheck && offset) {
        // 筛选未被勾选的项，且保证在最大可选数量
        const data = this.tableData.filter((row) => !row.check).slice(0, offset)
        const newValue = this.value.concat(data)
        this.$emit('input', newValue)
      }

      // 取消全选
      if (!isCheck) {
        const otherRows = this.value.filter((v) => !this.data.some((row) => row.id === v.id))
        this.$emit('input', otherRows)
      }
    },
    /**
     * @description: 删除结果
     * @param: items[]
     */
    removeItem(item) {
      const newResults = this.value.filter((row) => row.id !== item.id)
      this.$emit('input', newResults)
    },
    /**
     * @description: 清空全部已选结果
     */
    removeAll() {
      this.$emit('input', [])
    },
    /**
     * @description: 执行远程搜索
     */
    onSearchStringChange() {
      clearTimeout(timer)
      timer = setTimeout(() => {
        this.remoteMethod(this.searchValue)
      }, 200)
    },
    /**
     * @description: 当达到最大选取值时，为cell添加禁用样式
     * @param {*} cell
     */
    onCellHover(row, column, cell) {
      const parentNode = cell.parentNode
      parentNode.classList.remove('row-disabled')

      const checkCell = parentNode.querySelector('.el-checkbox.is-checked')

      if (!checkCell && this.seletcLimit) {
        parentNode.classList.add('row-disabled')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~common/styles/element-ui/variables.scss';

.remote-table {
  border: 1px solid #dee4f5;
  border-radius: 4px;
  height: 320px;

  display: flex;

  ::v-deep .row-disabled {
    cursor: not-allowed;
  }

  .display-box {
    padding: 10px;
    flex: 1;
    .data-table {
      margin-top: 5px;
    }
  }

  .row-list {
    height: 285px;
    overflow: auto;
    .row-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      cursor: pointer;
      font-size: 12px;
      margin-bottom: 0;

      > span {
        display: block;
        width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .remove {
        display: none;
      }

      &:hover,
      &.active {
        background: #eee;
      }

      &:hover {
        .remove {
          display: inline-block;
        }
      }
    }
  }

  .results-box {
    border-left: 1px solid #dee4f5;
    flex-basis: 20%;

    .header {
      display: flex;
      justify-content: space-between;
      line-height: 34px;
      font-size: 12px;
      background: #f2f2f2;
      border-bottom: 1px solid #dee4f5;
      padding: 0 10px;
      .clear {
        color: $primary-color;
        cursor: pointer;
      }
    }
  }
}
</style>
